
import React from "react";


function SignIn (){
    return(
        <div className="dashboard" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" , color: "navy"}}>
            {/* <h1>Dashboard</h1> */}
            <h1 style={{ marginTop: "0.1em", marginBottom: "0.3em" }}>
              Sign In
            </h1>

        </div>
    );

}

export default SignIn;